<template>
    <div>
        <el-dialog v-model="paySuccessShow" title="Tips" width="500" :show-close="false" :align-center="true"
            :close-on-click-modal="false">
            <template #header>
                <div class="header">支付成功</div>
                <div class="close_icon" @click="closePopup">
                    <el-icon :size="20">
                        <CloseBold />
                    </el-icon>
                </div>
            </template>
            <div class="dialog_content flex flexcolumn Flexalign">
                <el-image class="pay_success_img mt-20 mar_left_20" :src="iconPath('pay_success_img.png')"></el-image>
                <div class="success_text mt-20">恭喜！您的专属学习之旅已启程~可在个人中心查看历史购买试卷</div>
                <div class="btn mt-30 cursor_pointer" @click="goPaper">查看试卷</div>
                <div class="mt-15 cursor_pointer" @click="goIndex">返回首页</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "GjkcH5PaySuccess",

    data() {
        return {
            paySuccessShow: false,
        };
    },

    mounted() { },

    methods: {
        closePopup() {
            this.paySuccessShow = false;
        },
        goPaper(){
            this.href("/personalCenter",{selectMenu:6});
        },
        goIndex(){
            this.href("/");
        }
    },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
    width: 450px;
    // height: 512px;
    background: linear-gradient(180deg, #DEFFF8 0%, #FFFFFF 29%, #FFFFFF 100%);
    border-radius: 29px;
    position: relative;
}

:deep(.el-dialog__header) {
    position: relative;
    padding: 0 10px 0 20px;
    box-sizing: border-box;
    text-align: center;
}

.header {
    text-align: center;
    //   font-weight: bold;
    font-size: 20px;
    color: #333333;
    line-height: 60px;
    border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #333333;
}

.dialog_content {
    .pay_success_img {
        width: 200px;
    }

    .success_text {
        width: 80%;
        font-weight: 500;
        font-size: 20px;
        color: #303030;
    }

    .btn {
        width: 227px;
        height: 48px;
        background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
        border-radius: 30px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 48px;
        text-align: center;
    }
}
</style>